import { Outlet, useLocation, useNavigate } from 'react-router';
import { Box, Container, Stack, Tab, Tabs, Typography } from '@mui/material';

import { Icon, IconProps } from '../../shared/Icon';

import { RoutePath } from '../../routes';

const TABS: {
    label: string;
    path: string;
    icon: IconProps['name'];
    description: string;
}[] = [
    {
        label: 'Gift Scheduler',
        path: RoutePath.GiftsV2Scheduler,
        icon: 'calendar_month',
        description: 'Schedule finished gifts onto the live content calendar.',
    },
    {
        label: 'Gift Planner',
        path: RoutePath.GiftsV2Planner,
        icon: 'event',
        description: 'Plan upcoming gifts and track their production in Jira.',
    },
    {
        label: 'Gift Library',
        path: RoutePath.GiftsV2Library,
        icon: 'inventory_2',
        description:
            'Browse all gifts by their gift date, including unpublished gifts.',
    },
];

export const GiftsV2Layout = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const activeIndex = Math.max(
        0,
        TABS.findIndex((tab) => pathname.startsWith(tab.path)),
    );
    const activeTab = TABS[activeIndex];

    return (
        <Container maxWidth={false} sx={{ py: 3 }}>
            <Stack sx={{ mb: 1 }} spacing={0.5}>
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: 'center' }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            fontSize: 28,
                            color: 'primary.main',
                        }}
                    >
                        <Icon name="redeem" />
                    </Box>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{ fontWeight: 700 }}
                    >
                        Gifts
                    </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    {activeTab.description}
                </Typography>
            </Stack>

            <Tabs
                value={activeIndex}
                onChange={(_, index) => navigate(TABS[index].path)}
                sx={{
                    mb: 3,
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                {TABS.map((tab) => (
                    <Tab
                        key={tab.path}
                        label={tab.label}
                        iconPosition="start"
                        icon={
                            <Box sx={{ display: 'flex', fontSize: 20 }}>
                                <Icon name={tab.icon} />
                            </Box>
                        }
                        sx={{ minHeight: 48, textTransform: 'none' }}
                    />
                ))}
            </Tabs>

            <Outlet />
        </Container>
    );
};
